import { render } from "./existingDetails.vue?vue&type=template&id=fddbdaa6&scoped=true"
import script from "./existingDetails.vue?vue&type=script&lang=js"
export * from "./existingDetails.vue?vue&type=script&lang=js"

import "./existingDetails.vue?vue&type=style&index=0&id=fddbdaa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fddbdaa6"]])

export default __exports__